import { cn } from '@/lib/utils'

type KpiBadgeVariant = 'info' | 'warning' | 'error' | 'none'

interface KpiBadgeProps {
  value: number
  variant?: KpiBadgeVariant
  className?: string
}

const dotColors: Record<Exclude<KpiBadgeVariant, 'none'>, string> = {
  info: 'bg-background-positive-bold',
  warning: 'bg-background-notice-bold',
  error: 'bg-content-negative-bold',
}

export function KpiBadge({ value, variant = 'none', className }: KpiBadgeProps) {
  return (
    <div
      className={cn(
        'relative inline-flex items-center justify-center bg-surface-L2 rounded-lg h-[25px] min-w-[25px] px-[9px] py-[3px]',
        className
      )}
    >
      <span className="text-xs font-medium text-content-primary-bold leading-4 whitespace-nowrap">
        {value}
      </span>
      {variant !== 'none' && (
        <span
          className={cn(
            'absolute top-[-2px] right-[-2px] size-[9px] rounded-full',
            dotColors[variant]
          )}
        />
      )}
    </div>
  )
}
